import React from 'react';
import './Section4.css'


const Section4 = () => {

  return (
<section className="services section-padding py-5">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h2 className="section-title fw-bold">Servicios</h2>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-4 position-relative">
            <div className="single-service">
              <div className="service-shape">
                <i className="bi bi-car-front"></i>
              </div>
              <h5 className="mt-3 text-center">
                <i className="bi bi-car-front me-2"></i>Parqueadero
              </h5>
              <p className="text-center">Privado gratis en nuestras instalaciones.</p>
              <br/>
              <br/>


            </div>
          </div>

          <div className="col-md-4 position-relative">
            <div className="single-service">
              <div className="service-shape">
                <i className="bi bi-person-circle"></i>
              </div>
              <h5 className="mt-3 text-center">
                <i className="bi bi-person-circle me-2"></i>Círculo de mujeres
              </h5>
              <p className="text-center" style={{ paddingBottom: '8px' }}>Es una práctica milenaria donde se reúnen varias mujeres con una guía de meditación en torno al sagrado femenino, este es una experiencia que trasciende lo racional desde el corazón.</p>
            </div>
          </div>

          <div className="col-md-4 position-relative">
            <div className="single-service">
              <div className="service-shape">
                <i className="bi bi-wifi"></i>
              </div>
              <h5 className="mt-3 text-center">
                <i className="bi bi-wifi me-2"></i>WiFi
              </h5>
              <p className="text-center">En puntos estratégicos.</p>
              <br/>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Section4
